import { createAsyncThunk } from "@reduxjs/toolkit";
import setBaseURL from "../libs/utilities/helpers/BaseURLHelper";
import { api } from "./config/axiosConfig";

const DEV_BASE_URL = process.env.REACT_APP_BASE_URL;

export const getCallSummarizerReport = createAsyncThunk(
    "/summary/call-summarizer/report",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/summary/call-summarizer/report", data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);


export const uploadCallSummarizerReport = createAsyncThunk(
    "/summary/call-summarizer",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/summary/call-summarizer", data, {
                headers: {
                    "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);


export const checkCallSummarizerStatus = createAsyncThunk(
    "/summary/call-summarizer/service/get",
    async () => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post('/summary/call-summarizer/service/get');
           
            return response.data;
        } catch (error) {
           
            return error;
        }
    }
);

export const deleteCallSummarizerReport = createAsyncThunk(
    "/summary/call-summarizer/report/delete",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/summary/call-summarizer/report/delete", data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);